<template>
  <div class='lifetime-fyf'>
    <div
      id='ahc-lifetime-find-your-future-wrapper'
      class="lifetime-fyf-wrapper"
      :class="currentPage == 'welcome' || currentPage == 'cohabiting' ? 'lifetime-fyf-wrapper--shorter-page' : ''"
    >
      <Scene :isLoading="isOnLoadingPage" />

      <main class="main" role="main">
        <HeaderFyF />
        <Transition name='transition-all-pages-toggle' mode="out-in" appear>
          <WelcomePage
            v-if="isOnPage('welcome')"
            v-show='showForeground'
          />

          <QPageCohabiting
            v-else-if="isOnPage('cohabiting')"
            v-show='showForeground'
          />
          <QPageLocation
            v-else-if="isOnPage('location')"
            v-show='showForeground'
          />
          <QPageHomeFurnishing
            v-else-if="isOnPage('homeFurnishing')"
            v-show='showForeground'
          />
          <QPageCommunications
            v-else-if="isOnPage('communications')"
            v-show='showForeground'
          />
          <QPageFood
            v-else-if="isOnPage('eatingIn')"
            v-show='showForeground'
          />
          <QPageEatingOut
            v-else-if="isOnPage('eatingOut')"
            v-show='showForeground'
          />
          <QPageTransport
            v-else-if="isOnPage('transport')"
            v-show='showForeground'
          />
          <QPageHolidays
            v-else-if="isOnPage('holidays')"
            v-show='showForeground'
          />
          <QPageLeisure
            v-else-if="isOnPage('leisure')"
            v-show='showForeground'
          />
          <QPagePersonal
            v-else-if="isOnPage('personal')"
            v-show='showForeground'
          />
          <QPageHealth
            v-else-if="isOnPage('health')"
            v-show='showForeground'
          />

          <LoadingPage v-else-if="isOnPage('loading')" />

          <ResultsPage
            v-else-if="isOnPage('results')"
            v-show='showForeground'
          />

          <DisclaimerAndAssumptionsPage
            v-else-if="isOnPage('disclaimer-and-assumptions')"
            v-show='showForeground'
          />
        </Transition>

        <BackButton
          v-if='isOnQuestionPage'
          v-show='showForeground'
          class="hide-on-mobile"
        />

        <ProgressBar
          v-if='isOnQuestionPage'
          v-show='showForeground'
        />
      </main>
    </div>
    <LifetimeFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapFields } from "vuex-map-fields";

import 'autonumeric/dist/autoNumeric';
import BackButton from './components/BackButton.vue';
import ProgressBar from './components/ProgressBar.vue';

import WelcomePage from './views/WelcomePage.vue';
import Scene from "./views/Scene.vue";
import LoadingPage from "./views/LoadingPage.vue";
import ResultsPage from "./views/ResultsPage.vue";
import DisclaimerAndAssumptionsPage from "./views/DisclaimerAndAssumptionsPage.vue";
import HeaderFyF from "./views/HeaderFyF.vue";
import LifetimeFooter from "./components/LifetimeFooter.vue";
import clientConfig from '/src/config/client.js';

import QPageCohabiting from "./views/Questions/Cohabiting.vue";
import QPageLocation from "./views/Questions/Location.vue";
import QPageHomeFurnishing from "./views/Questions/HomeFurnishing.vue";
import QPageCommunications from "./views/Questions/Communications.vue";
import QPageFood from "./views/Questions/Food.vue";
import QPageEatingOut from "./views/Questions/EatingOut.vue";
import QPageTransport from "./views/Questions/Transport.vue";
import QPageHolidays from "./views/Questions/Holidays.vue";
import QPageLeisure from "./views/Questions/Leisure.vue";
import QPagePersonal from "./views/Questions/Personal.vue";
import QPageHealth from "./views/Questions/Health.vue";

export default {
  components: {
    WelcomePage,
    Scene,
    LoadingPage,
    ResultsPage,
    DisclaimerAndAssumptionsPage,
    HeaderFyF,
    LifetimeFooter,
    QPageCohabiting,
    QPageLocation,
    QPageHomeFurnishing,
    QPageCommunications,
    QPageFood,
    QPageEatingOut,
    QPageTransport,
    QPageHolidays,
    QPageLeisure,
    QPagePersonal,
    QPageHealth,
    BackButton,
    ProgressBar,
    },
  data () {
    return {
      clientConfig
    };
  },
  computed: {
    ...mapFields([
      'ui.showForeground',
      'ui.currentPageIndex',
    ]),
    ...mapGetters([
      'isOnPage',
      'currentPage',
      'isOnQuestionPage',
    ]),
    isOnWelcomePage: function () {
      return this.isOnPage('welcome');
    },
    isOnLoadingPage: function () {
      return this.isOnPage('loading');
    },
  },
  methods: {
    setTitle () {
      if (typeof this.clientConfig.content === 'object' && typeof this.clientConfig.content.title === 'string') {
        document.title = this.clientConfig.content.title
      }
    },
  },
  mounted () {
    this.setTitle()
  }
};
</script>

